<ng-container *transloco="let _t">

<div class="row darkbg head">
	<div class="col-1">
		{{answerName}}
	</div>
	<div class="col-3">
		{{objectif.building.name}}
	<small>( {{ objectif.building.BuildingType.name}} )</small>
	</div>
	<div class="col-4">
		{{objectif.name}}
	</div>
	<div class="col-2">
		{{objectif.start | date:'shortDate':undefined:'fr-FR'}} 
		- {{objectif.end | date:'shortDate':undefined:'fr-FR'}}
	</div>
	<div class="col-2">Budget : {{objectif.budget}} €</div>
</div>



<div class="row body">
	<div class="col-1 text-center">
		<mat-icon [ngStyle]="{'color': answerColor}" class="puce" >
		  radio_button_checked</mat-icon>
	</div>
	<div class="col-3 building">
		<cmat-picture
			[src]="objectif.building.photo" alt="Image" 
			[zoomed]="true" [uploadable]="false">
		</cmat-picture>
		<address>
			{{objectif.building.adress1}} - {{objectif.building.adress2}}<br/>{{objectif.building.zipcode}} {{objectif.building.town}}
			({{objectif.building.country}})
		</address>
		<p>
		<strong>{{ _t('rm-objectif-resume-strong-0') }} </strong><br>
		{{objectif.building.User.name}}<br>{{objectif.building.User.phone}}<br>
		<a [href]="'mailto:'+objectif.building.User.email">{{objectif.building.User.email}}</a>
		
		</p>
	</div>
	<div class="col-4">{{objectif.redaction}}</div>
	<div class="col-2">
		<button mat-raised-button *ngIf="!showDougnut" 
			color="primary"
			(click)="showDougnut=true;">
			<mat-icon>donut_small</mat-icon> 
			{{ _t('rm-objectif-resume-button-0')}}
		</button>
		
		<rm-objectif-doughnut *ngIf="showDougnut"
			class="small"
			[ratio]="objectif.ratio"
			[showTitle]="true"
			[showLegend]="true"
			[animation]="false">
		</rm-objectif-doughnut>
		
	</div>
	<div class="col-2 text-end btncell">
		<p>
	      <button mat-raised-button color="basic" 
			(click)='open()'>
			<mat-icon class="md-12">date_range</mat-icon> 
			{{ _t('rm-objectif-resume-button-1') }}
		  </button>
		</p>
	</div>

</div>

</ng-container>